import domReady from '@wordpress/dom-ready';

domReady(() => {
  const toggles = document.querySelectorAll('.toggle-categories');

  toggles.forEach((button) => {
    button.addEventListener('click', () => {
      const wrapper = button.closest('.expert-item__categories');

      const isExpanded = wrapper.classList.toggle('is-expanded');

      button.classList.toggle('is-open', isExpanded);
    });
  });
});
